import {
  Radio as MantineRadio,
  type RadioProps as MantineRadioProps,
} from '@mantine/core';
import clsx from 'clsx';

import { SVGIcon } from '../icons/SVGIcon';

import styles from './radio-group.module.scss';

export type RadioProps = {
  labelIconName?: string;
} & MantineRadioProps;

const CustomRadioCheckSVG: MantineRadioProps['icon'] = ({
  className,
  style,
}) => (
  <span className={clsx(styles['radio-icon'], className)} style={style}>
    <SVGIcon name="radio" />
  </span>
);

export function Radio({
  className,
  classNames,
  labelIconName,
  ...props
}: RadioProps) {
  const userClassNames =
    typeof classNames === 'function' ? undefined : classNames;

  return (
    <MantineRadio
      {...props}
      classNames={{
        ...userClassNames,
        root: clsx(styles['radio-input'], userClassNames?.root, className),
        inner: clsx(styles['inner'], userClassNames?.inner),
        radio: clsx(styles['radio'], userClassNames?.radio),
        icon: clsx(styles['icon'], userClassNames?.icon),
        label: clsx(styles['label'], userClassNames?.label),
      }}
      icon={CustomRadioCheckSVG}
    />
  );
}
